import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'panel.content.'

@vsingleton()
export class PanelContentItemRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'items.'

  getItems() {
    return this.ziggyRoute('get-items')
  }

  show(item: number) {
    return this.ziggyRoute('show', item)
  }

  showContent(item: number) {
    return this.ziggyRoute('show_content', item)
  }

  sendToRejected(item: number) {
    return this.ziggyRoute('send_to_rejected', item)
  }

  downloadContent(item: number) {
    return this.ziggyRoute('download_content', item)
  }
}
